<template>
    <div>
     
      <ba-search-card legend="Statistiques général" style="margin-bottom: 20px;">
          <div v-if="infoGeneral" style="margin: 0px 20px 20px 20px;">
            <div>Total CNIT/Mines validé: {{infoGeneral.cnitMinesValid}}</div>
            <div>Total CNIT/Mines non validé: {{infoGeneral.cnitMinesNotValid}}</div>
            <div>Total CNIT/Mines rentrés: {{infoGeneral.cnitMinesAll}}</div>
          </div>
          <div class="loading" v-if="loadingGeneral">
                <mo-loader :loading="loadingGeneral"></mo-loader>
              </div>
      </ba-search-card>
      <ba-search-card legend="Recherche" style="margin-bottom: 20px;">
          <form @submit.prevent="handleFilterResults">
              <div style="display: flex;margin: 20px;">
                  <section class="basic-date date-width" style="margin-right: 10px;max-width:250px; ">
                  <label>{{ $t('text.dateStart') }}</label>
                  <datepicker
                    name="start"
                    id="start"
                    class="basic-datepicker position-right"
                    format="dd/MM/yyyy"
                    v-model="date_min"
                    :highlighted="highlighted"
                    :monday-first="true"
                    :language="fr"
                 
                  >
                  </datepicker>
                  <ab-icon icon="calendar" iconset="calendarSet"></ab-icon>
                </section>
              <section class="basic-date date-width" style="max-width:250px; ">
                  <label>{{ $t('text.dateEnd') }}</label>
                  <datepicker
                    name="end"
                    id="end"
                    class="basic-datepicker position-right"
                    format="dd/MM/yyyy"
                    v-model="date_max"
                    :highlighted="highlighted"
                    :monday-first="true"
                    :language="fr"
                 
                  >
                  </datepicker>
                  <ab-icon icon="calendar" iconset="calendarSet"></ab-icon>
                </section>
                  <div class="search-buttons-ctn">
                    <div class="buttons-container flex flex-end">
                      <span class="filter-link" @click="handleResetFilter">{{ $t('action.resetFilter') }}</span>
                      <ba-button class="primary" :disabled="filterOnGoing">{{ $t('action.search') }}</ba-button>
                    </div>
                  </div>
              </div>
              
          </form>
      </ba-search-card>
        <div v-if="infoFilter == null" class="no-data">
                Pas d'information sur le resultat de la recherche
         </div>
         
      <ba-search-card v-else legend="">
            <div style="margin: 0px 20px 20px 20px;">
                <div>Total CNIT/Mines validé: {{ infoFilter.cnitMinesValid }}</div>
                <div>Total CNIT/Mines non validé: {{ infoFilter.cnitMinesNotValid }}</div>
                <div>Total CNIT/Mines rentrés: {{ infoFilter.cnitMinesAll }}</div>
              </div>
         
      </ba-search-card>

<!--      <div class="loading" v-if="loading">
        <mo-loader :loading="loading"></mo-loader>
      </div>-->
    
        

    
          </div>
</template>

<script>
import { mapState } from 'vuex';
import { AbIcon, BaButton, BaCard, BaDropdown, BaInput, BaSearch, BaSearchCard, BaSelect, BaStateLabel, BaTable } from '@ab/basic-components';

import { fr } from 'vuejs-datepicker/dist/locale';

import paginationMixin from '@/components/mixins/pagination.js';
import requestMixin from '@/components/mixins/request.js';
import searchMixin from '@/components/mixins/search.js';
import sortableMixin from '@/components/mixins/sortable.js';
import { generateSearchWatcher } from '@/assets/js/helpers.js';
import MoLoader from '@/components/loader/mo-loader.vue';

import Datepicker from 'vuejs-datepicker';

export default {
  name: 'DocumentList-statistique',
  components: {
    AbIcon,
    BaButton,
    BaCard,
    BaDropdown,
    BaInput,
    BaSearch,
    BaSearchCard,
    BaSelect,
    BaStateLabel,
    BaTable,
    Datepicker,
    MoLoader
  },
  data() {
    return {
      highlighted: {
        dates: [
          new Date()
        ]
      },
      fr: fr,
      isDisabled: false,
      computedDisabledDateFrom: false,
      stateFicheArticle:'general',
      userRole: this.$store.getters.getUserRole,
      date_max: '',
      date_min: '',
      filterOnGoing: false,
      infoFilter:null,
      infoGeneral:null,
      loadingGeneral:true
    };
  },
  computed: {

  },
  async mounted() {
      //chargement des statistique general
      this.infoGeneral = {};
      this.loadingGeneral = false;
      const data = await this.$store.dispatch('getStatCnitMine', {
          date_min:null,
          date_max:null
      });
      this.infoGeneral = data;
    
  },
  methods: {
    
    async handleFilterResults() {
        const data = await this.$store.dispatch('getStatCnitMine', {
          date_min:this.date_min,
          date_max:this.date_max
      });
      this.infoFilter = data;
        
    },
    handleResetFilter() {

      this.date_max = '';
      this.date_min = '';

    },
   
  }
  
};
</script>

<style src="@/assets/styles/datepickers.css"></style>

